export default "__VITE_ASSET__BIPn535G__"